var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconAp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 32.875V31C30.125 30.0054 29.7299 29.0516 29.0267 28.3483C28.3234 27.6451 27.3696 27.25 26.375 27.25H20.75C19.7554 27.25 18.8016 27.6451 18.0983 28.3483C17.3951 29.0516 17 30.0054 17 31V32.875",
    stroke: "#007DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 19.75C19.8125 20.7446 20.2076 21.6984 20.9108 22.4017C21.6141 23.1049 22.5679 23.5 23.5625 23.5C24.5571 23.5 25.5109 23.1049 26.2142 22.4017C26.9174 21.6984 27.3125 20.7446 27.3125 19.75C27.3125 18.7554 26.9174 17.8016 26.2142 17.0983C25.5109 16.3951 24.5571 16 23.5625 16C22.5679 16 21.6141 16.3951 20.9108 17.0983C20.2076 17.8016 19.8125 18.7554 19.8125 19.75Z",
    stroke: "#007DD4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconAp);
export default __webpack_public_path__ + "static/media/UserIconAP.a6953760f6177987cd66e153d0569c51.svg";
export { ForwardRef as ReactComponent };